import { KeyValueStorage } from './KeyValueStorage';

export function createMemoryKeyValueStorage(): KeyValueStorage {
  const storage = new Map<string, string>();

  function setItem(key: string, value: string): void {
    storage.set(key, value);
  }

  function getItem(key: string): string | undefined {
    return storage.get(key);
  }

  function removeItem(key: string): void {
    storage.delete(key);
  }

  function clear(): void {
    storage.clear();
  }

  return {
    setItem,
    getItem,
    removeItem,
    clear,
  };
}
